/* eslint import/prefer-default-export: "off" */

export function isUpperCase(str) {
  return str === str.toUpperCase()
}
export function validatePassword(password: string) {
  if (password.length < 10) {
    return 'Password should be at least 10 characters long'
  } else if (!password.match(/[a-z]/)) {
    return 'Password should contain lowercase letters'
  } else if (!password.match(/[A-Z]/)) {
    return 'Password should contain uppercase letters'
  } else if (password.match(/^\s+|\s+$/g)) {
    return 'Password should start and end from non-whitespace character'
  } else if (
    !password.match(/[!@#\$%\^\&*\)\(+=,._\-`~\[\]\{\}\\|;:'"<>/\?]/) // eslint-disable-line no-useless-escape
  ) {
    return 'Password should contain a special character'
  }
  return null
}

export const passwordMessage =
  'Password must be at least 10 characters long. It should contain uppercase, lowercase and special characters.'
